/* eslint-disable camelcase */
import { createSelector } from 'reselect';
import moment from 'moment';
import configSelector from './config';

export default createSelector(
  (state) => state.filters,
  (state) => state.profile,
  configSelector,
  (payload, profile, { formatDate }) => {
    const { dates, others, terms, dataType, includeRepartitionCharge, ...rest } = payload;

    const {
      payload: { analytics_type },
    } = profile;

    // Funzione per pulire i dati e rimuovere riferimenti circolari
    // Only store type, label, color - value and isExclusive are derived from filters/terms
    const cleanFilterData = (filter) => ({
      type: String(filter.type || ''),
      label: String(filter.label || ''),
      color: String(filter.color || ''),
    });

    // Estraggo tipo e valore da filter.value (es. "store_id=44"). Salto le entry
    // malformate o prive di value (può capitare con stati persistiti vecchi o
    // ricostruiti da query string) per evitare crash su .split di undefined.
    const buildFilterString = (collection) =>
      Object.keys(collection)
        .map((key) => {
          const item = collection[key];
          if (!item || typeof item.value !== 'string' || !item.value.includes('=')) return null;
          const [itemType, itemValue] = item.value.split('=');
          const prefix = item.isExclusive ? '-' : '';
          return `${itemType}=${prefix}${itemValue}`;
        })
        .filter(Boolean)
        .join(',');

    const othersToString = buildFilterString(others);
    let termsToString = buildFilterString(terms);

    let repartitionsFilter;
    const hasPublisher = Object.keys(others).some((key) => key.includes('publisher'));

    if (hasPublisher) repartitionsFilter = 'document_source_type=-repartition_credit';

    if (!includeRepartitionCharge) {
      repartitionsFilter =
        'document_source_type=-repartition_charge,document_source_type=-repartition_credit';
    }

    if (repartitionsFilter) {
      if (termsToString.length) termsToString = `${termsToString},${repartitionsFilter}`;
      else termsToString = repartitionsFilter;
    }

    // Pulisco i dati dei filtri per evitare problemi di serializzazione JSON
    const cleanFiltersData = Object.keys(others).reduce((acc, key) => {
      try {
        acc[key] = cleanFilterData(others[key]);
      } catch (error) {
        // Se c'è un errore, creo un filtro pulito di fallback
        acc[key] = cleanFilterData({
          type: 'unknown',
          label: 'Unknown',
          color: 'black',
        });
      }
      return acc;
    }, {});

    const cleanTermsData = Object.keys(terms).reduce((acc, key) => {
      try {
        acc[key] = cleanFilterData(terms[key]);
      } catch (error) {
        // Se c'è un errore, creo un termine pulito di fallback
        acc[key] = cleanFilterData({
          type: 'unknown',
          label: 'Unknown',
          color: 'black',
        });
      }
      return acc;
    }, {});

    return {
      ...rest,
      dataType:
        dataType === 'aggregated_data' && analytics_type?.match(/split/)
          ? 'temporary_data'
          : dataType,
      dateFrom: moment(dates[0]).format(formatDate),
      dateTo: moment(dates[1]).format(formatDate),
      filters: othersToString,
      terms: termsToString,
      filtersData: JSON.stringify(cleanFiltersData),
      termsData: JSON.stringify(cleanTermsData),
    };
  },
);
